export const FETCH_USER_LIST_BEGIN = "FETCH_USER_LIST_BEGIN";
export const FETCH_USER_LIST_FAILURE = "FETCH_USER_LIST_FAILURE";
export const FETCH_USER_LIST_SUCCESS = "FETCH_USER_LIST_SUCCESS";
